// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"173":"57e90761","486":"53327811","510":"53327811","637":"ef19794e","831":"57e90761"}[chunkId] + ".chunk.css";
};